import store from '..';
import { Tickets, Utils } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer, resetReducer,
    getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction, resetAction
} = createRestSlices(Tickets);

initialState.filters                     = {};
initialState.isImporting                 = false;
initialState.hasImportingError           = false;
initialState.importingErrorMessage       = '';
initialState.updatedWallets              = null;
initialState.isUpdatingWallets           = false;
initialState.hasUpdatingWalletsError     = false;
initialState.updatingWalletsErrorMessage = '';

const IMPORTING_TICKETS         = 'kronos/tickets/IMPORTING_TICKETS';
const IMPORTING_TICKETS_SUCCESS = 'kronos/tickets/IMPORTING_TICKETS_SUCCESS';
const IMPORTING_TICKETS_FAILURE = 'kronos/tickets/IMPORTING_TICKETS_FAILURE';
const RESET_WALLETS_UPDATE      = 'kronos/tickets/RESET_WALLETS_UPDATE';
const UPDATING_WALLETS          = 'kronos/tickets/UPDATING_WALLETS';
const UPDATING_WALLETS_SUCCESS  = 'kronos/tickets/UPDATING_WALLETS_SUCCESS';
const UPDATING_WALLETS_FAILURE  = 'kronos/tickets/UPDATING_WALLETS_FAILURE';
const UPDATING_FILTERS          = 'kronos/tickets/UPDATING_FILTERS';

const reducer = (state, action) => {
    switch (action.type) {
        case IMPORTING_TICKETS:
            return {
                ...state,
                isImporting: true,
                hasImportingError: false
            };
        case IMPORTING_TICKETS_SUCCESS:
            return {
                ...state,
                isImporting: false,
                hasImportingError: false,
                imported: action.imported
            };
        case IMPORTING_TICKETS_FAILURE:
            return {
                ...state,
                isImporting: false,
                hasImportingError: true,
                tktsyncingErrorMessage: action.error.message
            };
        case RESET_WALLETS_UPDATE:
            return {
                ...state,
                updatedWallets: null,
                isUpdatingWallets: false,
                hasUpdatingWalletsError: false,
                updatingWalletsErrorMessage: ''
            };
        case UPDATING_WALLETS:
            return {
                ...state,
                isUpdatingWallets: true,
                hasUpdatingWalletsError: false
            };
        case UPDATING_WALLETS_SUCCESS:
            return {
                ...state,
                updatedWallets: action.updatedWallets,
                isUpdatingWallets: false,
                hasUpdatingWalletsError: false,
                imported: action.imported
            };
        case UPDATING_WALLETS_FAILURE:
            return {
                ...state,
                isUpdatingWallets: false,
                hasUpdatingWalletsError: true,
                updatingWalletsErrorMessage: action.error.message
            };
        case UPDATING_FILTERS:
            return {
                ...state,
                filters: action.filters,
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer, resetReducer,
        reducer
    ]);
}

/* Export CRUD actions */
export const startCreateTicket = startCreateAction;
export const createTicket      = createAction;
export const loadTicket        = getAction;
export const resetTickets      = resetAction;
export const loadTickets       = listAction;
export const updateTicket      = updateAction;
export const deleteTicket      = deleteAction;
export const duplicateTicket   = duplicateAction;

export function updateTicketsFilters(filters) {
    return (dispatch) => {
        dispatch({ type: UPDATING_FILTERS, filters });
    }
}

function importingTickets() { return { type: IMPORTING_TICKETS } }
function importingTicketsSuccess(imported) { return { type: IMPORTING_TICKETS_SUCCESS, imported: imported } }
function importingTicketsFailure(err) { return { type: IMPORTING_TICKETS_FAILURE, error: err } }
export function importTickets(data) {
    return (dispatch) => {
        dispatch(importingTickets());
        Tickets.importTickets(data)
            .then(data => {
                const imported = data.imported;
                dispatch(importingTicketsSuccess(imported));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(importingTicketsFailure(err))
            });
    }
}

function updatingWallets() { return { type: UPDATING_WALLETS } }
function updatingWalletsSuccess(updatedWallets) { return { type: UPDATING_WALLETS_SUCCESS, updatedWallets } }
function updatingWalletsFailure(err) { return { type: UPDATING_WALLETS_FAILURE, error: err } }
export function resetWalletsUpdate() {
    return (dispatch) => dispatch({ type: RESET_WALLETS_UPDATE });
}
export function updateWallets(ids, mode, amount) {
    return (dispatch) => {
        dispatch(updatingWallets());
        Tickets.updateWallets(ids, mode, amount)
            .then(data => {
                const updatedWallets = data.wallets;
                dispatch(updatingWalletsSuccess(updatedWallets));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(updatingWalletsFailure(err))
            });
    }
}
